/** Networked dog reactions (floating icons above the pup, visible to everyone). */
export const REACTION_IDS = ["heart"] as const;
export type ReactionId = (typeof REACTION_IDS)[number];

export const REACT_COOLDOWN_MS = 1600;

export function isReactionId(value: string): value is ReactionId {
  return (REACTION_IDS as readonly string[]).includes(value);
}
